import { render, staticRenderFns } from "./FileManagerModal.vue?vue&type=template&id=36ba7df7"
import script from "./FileManagerModal.vue?vue&type=script&lang=js"
export * from "./FileManagerModal.vue?vue&type=script&lang=js"
import style0 from "./FileManagerModal.vue?vue&type=style&index=0&id=36ba7df7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports